import { render, staticRenderFns } from "./CreateCutting.vue?vue&type=template&id=2d566dc0"
import script from "./CreateCutting.vue?vue&type=script&lang=js"
export * from "./CreateCutting.vue?vue&type=script&lang=js"
import style0 from "./CreateCutting.vue?vue&type=style&index=0&id=2d566dc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports